import React, { Component } from "react";
import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import Default from "./components/Default";
import ErrorBoundary from "./components/ErrorBoundary";
import AgencyDashboard from "./components/desktop/agency-platform-dashboard/AgencyDashboard";
import AgencyProfile from "./components/desktop/agency-platform-profile/AgencyProfile";
import WelcomeSelect from "./components/desktop/auth-platform/WelcomeSelect";
import WelcomeLogin from "./components/desktop/auth-platform/WelcomeLogin";
import WelcomeScreenFirstTime from "./components/desktop/auth-platform/WelcomeScreenFirstTime";
import {
  clientDashboard,
  clientProfile,
  clientAddNewRequirement,
  clientdPreviewRequirement,
  agencyDashboard,
  agencyDashboardRequirementDetail,
  agencyDashboardClientProfile,
  agencyProfile,
  superAdminDashboard,
  superAdminClientDetails,
  superAdminAgencyDetails,
  superAdminProfile,
  superAdminDashboardRequirementDetails,
  addNewClient,
  addNewAgency,
} from "../src/components/desktop/common/allLinks";
import ClientDashboard from "./components/desktop/client-platform-dashboard/ClientDashboard";
import ClientProfile from "./components/desktop/client-platform-profile/ClientProfile";
import SuperAdminDashboard from "./components/desktop/super-admin-platform-dashboard/SuperAdminDashboard";
import SuperAdminProfile from "./components/desktop/super-admin-platform-profile/SuperAdminProfile";
import ClientDashboardAddNewRequirement from "./components/desktop/client-platform-dashboard/ClientDashboardAddNewRequirement";
import ClientDashboardPreviewRequirement from "./components/desktop/client-platform-dashboard/ClientDashboardPreviewRequirement";
import AgencyDashboardClientProfile from "./components/desktop/agency-platform-dashboard/AgencyDashboardClientProfile";
import AgencyDashboardRequirementDetails from "./components/desktop/agency-platform-dashboard/AgencyDashboardRequirementDetails";
import SuperAdminDashboardClientDetails from "./components/desktop/super-admin-platform-dashboard/SuperAdminDashboardClientDetails";
import SuperAdminDashboardAgencyDetails from "./components/desktop/super-admin-platform-dashboard/SuperAdminDashboardAgencyDetails";
import SuperAdminDashboardRequirementDetails from "./components/desktop/super-admin-platform-dashboard/SuperAdminDashboardRequirementDetails";
import AddNewClient from "./components/desktop/add-new-client/AddNewClient";
import AddNewAgency from "./components/desktop/add-new-agency/AddNewAgency";

export class App extends Component {
  constructor() {
    super();
    this.state = {
      // require for responsive window
      windowWidth: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
  }

  handleWindowResize = () => {
    this.setState({
      windowWidth: window.innerWidth,
    });
  };

  renderCommonRoutes = () => {
    return (
      <>
        <Route path="/" element={<WelcomeSelect />} />
        <Route path="/welcome-select" element={<WelcomeSelect />} />
        <Route path="/welcome" element={<WelcomeLogin />} />
        <Route
          path="/welcome-first-time"
          element={<WelcomeScreenFirstTime />}
        />

        {/* client */}
        <Route path={clientDashboard} element={<ClientDashboard />} />
        <Route path={clientProfile} element={<ClientProfile />} />
        <Route
          path={clientAddNewRequirement}
          element={<ClientDashboardAddNewRequirement />}
        />
        <Route
          path={clientdPreviewRequirement}
          element={<ClientDashboardPreviewRequirement />}
        />

        {/* agency */}
        <Route path={agencyDashboard} element={<AgencyDashboard />} />
        <Route
          path={agencyDashboardRequirementDetail}
          element={<AgencyDashboardRequirementDetails />}
        />
        <Route
          path={agencyDashboardClientProfile}
          element={<AgencyDashboardClientProfile />}
        />
        <Route path={agencyProfile} element={<AgencyProfile />} />
      </>
    );
  };

  render() {
    return (
      <Router>
        <ErrorBoundary>
          {/* desktop routes */}
          {this.state.windowWidth >= 768 && (
            <Routes>
              {/* super admin */}
              <Route
                path={superAdminDashboard}
                element={<SuperAdminDashboard />}
              />
              <Route
                path={superAdminClientDetails}
                element={<SuperAdminDashboardClientDetails />}
              />
              <Route
                path={superAdminAgencyDetails}
                element={<SuperAdminDashboardAgencyDetails />}
              />
              <Route
                path={superAdminDashboardRequirementDetails}
                element={<SuperAdminDashboardRequirementDetails />}
              />
              <Route path={superAdminProfile} element={<SuperAdminProfile />} />
              <Route path={addNewClient} element={<AddNewClient />} />
              <Route path={addNewAgency} element={<AddNewAgency />} />

              {this.renderCommonRoutes()}
              <Route path="*" element={<Default />} />
            </Routes>
          )}

          {/* mobile routes */}
          {this.state.windowWidth <= 767 && (
            <Routes>
              {this.renderCommonRoutes()}
              {/* default */}
              <Route path="*" element={<Default />} />
            </Routes>
          )}
        </ErrorBoundary>
      </Router>
    );
  }
}

export default App;
